/**
 * Centralized path constants so route strings aren't duplicated/hardcoded
 * across pages, links, and redirects.
 */
export const ROUTES = {
  home: "/",
  login: "/login",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  ssoCallback: "/sso-callback",
  teams: "/teams",
  /** Route pattern for `<Route path={...}>`. Use `teamDetailPath(id)` to build a real link. */
  teamDetailPattern: "/teams/:teamId",
  requests: "/requests",
  kanban: "/kanban",
  newRequest: "/requests/new",
  /** Route pattern for `<Route path={...}>`. Use `requestDetailPath(id)` to build a real link. */
  requestDetailPattern: "/requests/:requestId",
  users: "/users",
  auditLog: "/audit-log",
  analytics: "/analytics",
  notFound: "*",
} as const;

export function teamDetailPath(teamId: string): string {
  return `/teams/${teamId}`;
}

export function requestDetailPath(requestId: string): string {
  return `/requests/${requestId}`;
}
